import "./home.css";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import background_img from "./../../static/images/background_1.webp";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AppRoutes from "./../../routes.js";
import { actionTypes } from './../../store';
import ThemeFirstPage from './../themeFirstPage/themeFirstPage.js';
import Load from './../load/load.js';
import axios from "axios";

export default function Home() {
    const { token } = useParams();
    let navigate = useNavigate();
    const [data, setData] = useState(useSelector((state) => state.data));
    const [start, setStart] = useState(true);
    const [load, setLoad] = useState(true);
    const dispatch = useDispatch();

    async function getData() {
        try {
            const header = {Authorization: `Basic ${token}`}
            const response = await axios.get(
              `${AppRoutes.backend}get_data`,
                {headers: header}
            );
            if (response.data['uuid_document']){
                console.log('entrou')
                var final_data = {'UUID-DOCUMENTO':response.data?.uuid_document,'email':response.data?.email}
                dispatch({type:actionTypes.set_finish, payload:final_data})

            }
            else{
                if (!data){
                    dispatch({ type: actionTypes.set_data, payload: {...response.data,'token':token}});
                }
            }
            setData(response.data);
            setLoad(false);
        } catch (error) {
            console.error(error);
            setLoad(false);
        }
    }

    function setSignPage(){
        const intervalId = setInterval(() => navigate(AppRoutes.sign), 5000);
    }
    function setPage(status) {
        switch (status) {
          case "Incomplete":
            // Pessoa não preencheu ainda
            return (
              <>
                <span className="title-2">
                  Vamos ajudá-lo a entender como o seu DNA pode interferir em seus
                  tratamentos médicos.
                  <br />
                  Inicie a sua jornada preenchendo o formulário a seguir.
                </span>
                <button
                  className="btn btn-yellow"
                  onClick={() => navigate(AppRoutes.start)}
                >
                  Vamos lá
                </button>
              </>
            );
          case "Unsigned":
            // Falta apenas assinar
            setSignPage();
            return  <span className="title-2">
                        <p>Seu formulário já foi preenchido.</p>
                        <p>Aguarde enquanto redirecionamos para a assinatura digital.</p>
                    </span>;
          case "Signed":
            // Preenchido e Assinado.
            return <span className="title-2">
                        Seu formulário já foi preenchido e assinado digitalmente com sucesso!
                    </span>;
          case "Undefined":
            // Preenchido mas não foi possivel verificar se foi assinado ou não.
            return <span className="title-2">
                        Seu formulário já foi preenchido, mas não foi possivel verificar se foi assinado.
                        Entre em contato com o vendedor.
                    </span>;
          default:
            return <span className="title-2 text-center">
                        <p>Ocorreu um erro inesperado ao processar seu formulário!</p>
                        <p>Tente novamente, caso o erro persista entre em contato conosco.</p>
                    </span>;
        }
    }
  useEffect(() => {
    getData();
  }, []);
    return (
        <div className="home">
            <ThemeFirstPage color={(data?.status === 'Signed' || data?.status === 'Unsigned' ||
                                    data?.status === 'Undefined' ) && !start?'yellow':'blue'}>
                {start? (
                    <>
                      <span className="title">Bem-vindo à Saúde Personalizada!</span>
                      <button
                        className="btn btn-yellow"
                        onClick={() => setStart(false)}
                      >
                        Próximo
                      </button>
                    </>
                  ) : load?(
                    <Load message="Carregando..."/>
                    ):( setPage(data?.status) )}
            </ThemeFirstPage>
        </div>
  );
}
